import $ from 'jquery';

$(function () {
  $(document).on('click', '.copy-paste-button', function() {
    let url = $('.copy-btn-url').val();
    let messageSuccess = $('.share-copied-success');

    navigator.clipboard.writeText(url);
    messageSuccess.css('display', 'block');

    // Hide msg after 2s
    setTimeout(function () {
      messageSuccess.css('display', 'none');
    }, 2500);
  });

  const shareData = {
    title: $('h1').text(),
    url: window.location.href,
  };

  const resultPara = $('.result');

  $(document).on('click', '#share_button', function () {
    try {
      navigator.share(shareData).then(function () {});
      resultPara.text('La page a bien été partagée');
    } catch (error) {
      resultPara.text('Une erreur est survenue: ' + error);
    }
  });
});